import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { OccurencesService } from '../../occurences.service';
import { FormGroup } from '@angular/forms';
import { SnackbarService } from '../../../../app/shared/services/snackbar.service';
import { ConfirmDialogComponent } from '../../../shared/confirm-dialog/confirm-dialog.component';
import {MatBottomSheet} from '@angular/material';
import { UtilService } from '../../../../app/shared/utils';

@Component({
  selector: 'app-occurence-attachments',
  templateUrl: './occurence-attachments.component.html',
  styleUrls: ['./occurence-attachments.component.css']
})
export class OccurenceAttachmentsComponent implements OnInit {

  @Input('filesForm')
  public filesForm: FormGroup;

  @Input('filesToUpload')
  filesToUpload: Array<File> = new Array<File>();

  @Input()
  public isVisualization: boolean;

  @Input()
  filesSelected: any[];
  haveFiles: boolean;
  errorDownloadFile: boolean = false;

  constructor(
    private occurenceService: OccurencesService,
    private _snackbarService: SnackbarService,
    private bottomSheet: MatBottomSheet,
    private utils: UtilService
    ) { }

  ngOnInit() {
    if (this.filesSelected) {
      if (this.filesSelected.length > 0 || this.filesToUpload.length > 0) {
        this.haveFiles = true;
      }
    }
  }
    

  onEventFilesToUpload($event) {
    // Atualiza o form
    this.filesForm.controls.files.setValue(this.filesToUpload);
    if (this.filesToUpload) {
      this.haveFiles = this.filesToUpload.length === 0 ? false : true;
    }
  }

  // Checa a existência de um arquivo no array utilizando a propriedade name e retorna seu indice
  getUploadIndexByName(name: string): number {
    return this.filesToUpload.findIndex(upload => upload.name === name);
  }

  deleteAttachment(name: string, event) {
    let index = this.getUploadIndexByName(name);
    if (this.filesToUpload && index >= 0) {
      let sheetRef =  this.bottomSheet.open(ConfirmDialogComponent, {
        data: { message: 'Confirma a exclusão do arquivo?' }
      });
      sheetRef.afterDismissed().subscribe(data => {
        if(data && data.message === 'Confirm') {
          this.haveFiles = this.filesToUpload.length === 0 ? false : true;
          this.filesToUpload.splice(index, 1);
          this._snackbarService.showSnackbar("Arquivo excluído com sucesso.", "OK");
        }
      });
    } else {
      this._snackbarService.showSnackbar(`O arquivo não foi excluído. Por favor, tente novamente.
      Caso o problema persista, contate o seu canal de atendimento.`, "OK");
    }
  }

  getSizeText(file: File): string {
    return (file.size / Math.pow(1024,2)).toFixed(2).replace(/[.,]00$/, "") + " " + "MB";
  }

  downloadOccurenceFileById(idFile: number) {
    this.occurenceService
      .downloadOcurrenceFileById(idFile)
      .subscribe((resp) => {
        this.errorDownloadFile = false;
        const { body } = resp;
        const { fileName, contentFile } = body;
        const blob = this.utils.convertByteJsonToBlob(contentFile);
        this.utils.downloadFileBlob(blob, fileName);
      }, err => {
        this.errorDownloadFile = true;
      });
    }

  get listAttachmentsRecent() {
    if (this.filesSelected && Array.isArray(this.filesSelected) && this.filesSelected.length > 0) {
      return this.filesSelected.sort((a, b) => {
        return <any>new Date(b.update) - <any>new Date(a.update);
      });
    }
  }


}
